import { Router } from '@angular/router';
import { environment } from 'environments/environment';

export const getLogoutUrl = (): string | null => {
  if (environment.production) {
    return environment.landingPageUrl + '/logout';
  }
  return null;
};

export const navToSignIn = async (router: Router, tryWp = true) => {
  if (tryWp && environment.production) {
    window.location.href = environment.landingPageUrl + '/login';
  } else {
    router.navigate(['/auth/sign-in']);
  }
};

export const navToLogOut = async (router: Router) => {
  const logoutUrl = getLogoutUrl();
  if (logoutUrl) {
    window.location.href = logoutUrl;
  } else {
    router.navigate(['/']);
    setTimeout((_) => {
      window.location.reload();
    });
  }
};
